var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 1.1665C4.74283 1.1665 2.91699 2.99234 2.91699 5.24984C2.91699 8.31234 7.00033 12.8332 7.00033 12.8332C7.00033 12.8332 11.0837 8.31234 11.0837 5.24984C11.0837 2.99234 9.25783 1.1665 7.00033 1.1665ZM4.08366 5.24984C4.08366 3.63984 5.39033 2.33317 7.00033 2.33317C8.61033 2.33317 9.91699 3.63984 9.91699 5.24984C9.91699 6.92984 8.23699 9.444 7.00033 11.0132C5.78699 9.45567 4.08366 6.91234 4.08366 5.24984Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 6.70817C7.80574 6.70817 8.45866 6.05525 8.45866 5.24984C8.45866 4.44442 7.80574 3.7915 7.00033 3.7915C6.19491 3.7915 5.54199 4.44442 5.54199 5.24984C5.54199 6.05525 6.19491 6.70817 7.00033 6.70817Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.be782b91ceefb555cefae8afdeea0623.svg";
export { ForwardRef as ReactComponent };